import {
  type IconDefinition,
  faCheckCircle,
  faCircleThreeQuartersStroke,
  faExclamationCircle,
} from "@fortawesome/pro-solid-svg-icons";

export enum MessageStatuses {
  InProgress = "InProgress",
  Sent = "Sent",
  Failed = "Failed",
}

export const MessageStatusToIcon: { [key in MessageStatuses]: IconDefinition } = {
  InProgress: faCircleThreeQuartersStroke,
  Sent: faCheckCircle,
  Failed: faExclamationCircle,
};

export const MessageStatusToColor: { [key in MessageStatuses]: string } = {
  InProgress: "yellow",
  Sent: "green",
  Failed: "red",
};

export const MessageStatusToString: { [key in MessageStatuses]: string } = {
  InProgress: "In Progress",
  Sent: "Sent",
  Failed: "Failed",
};
